import { api, setToken, clearToken } from './client';

export interface AuthUser {
  id: number;
  name: string;
  email: string;
  role: string | null;
  status: string | null;
  phone?: string;
  icnum?: string;
  address?: string;
  access: string[];
}

export interface LoginResponse {
  success: true;
  token: string;
  user: AuthUser;
}

export const authApi = {
  login: async (email: string, password: string): Promise<LoginResponse> => {
    const r = await api<LoginResponse>('/api/v2/auth/login', { method: 'POST', body: { email, password } });
    if (r.token) {
      setToken(r.token);
      // Kick the followup scheduler back on now that auth is fresh.
      // The scheduler auto-stops itself when it sees a 401, so a
      // post-login restart is needed to resume polling.
      try {
        const mod = await import('../services/followupScheduler');
        mod.followupScheduler.start();
      } catch { /* non-fatal */ }
    }
    return r;
  },
  me: async (): Promise<AuthUser> => {
    const r = await api<{ success: boolean; user: AuthUser }>('/api/v2/auth/me');
    return r.user;
  },
  changePassword: async (currentPassword: string, newPassword: string) => {
    return api('/api/v2/auth/change-password', { method: 'POST', body: { currentPassword, newPassword } });
  },
  logout: () => {
    clearToken();
  },
};
